import { render } from "./ViewSavedDashboardCards.vue?vue&type=template&id=25c30f36"
import script from "./ViewSavedDashboardCards.vue?vue&type=script&lang=js"
export * from "./ViewSavedDashboardCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__